import type { ExpressionSpecification } from "maplibre-gl";
import { LAYER_CONFIG } from "./configs";
import {
  Coordinates,
  DataLayer,
  LayerControlState,
  SurfaceCoverConfig,
} from "./types";

export const getLayerHeight = (layer: DataLayer): ExpressionSpecification => [
  "case",
  layer.name === "building_parts" && ["has", "building_parts___top_height"],
  ["get", "building_parts___top_height"],
  layer.name === "solar_heights" && ["has", "height"],
  ["+", ["get", "height"], 0.2],
  ["has", "height"],
  ["get", "height"],
  layer.name === "building" ? 15 : 5,
];

export const getLayerBase = (layer: DataLayer): ExpressionSpecification => [
  "case",
  layer.name === "building_parts" && ["has", "building_parts___base_height"],
  ["get", "building_parts___base_height"],
  layer.name === "solar_heights" && ["has", "height"],
  ["get", "height"],
  0,
];

export const createVectorTileSource = (layer: DataLayer) => ({
  type: "vector" as const,
  tiles: [
    `https://chatswood-demo-v2.s3.ap-southeast-2.amazonaws.com/chatswood-demo/${layer.folder}/{z}/{x}/{y}.pbf`,
  ],
  minzoom: 0,
  maxzoom: 18,
});

export const createInitialControlState = (): LayerControlState => {
  return LAYER_CONFIG.reduce((acc, config) => {
    if (config.type === "checkbox" || config.type === "switch") {
      acc[config.id] = config.enabled ?? false;
    } else if (config.type === "selector") {
      acc[config.id] = config.value ?? "";
    }
    if (config.radioOptions) {
      acc[`${config.id}-radio`] =
        config.radioOptions.find((opt) => opt.selected)?.value || "default";
    }
    return acc;
  }, {} as LayerControlState);
};

export const CHATSWOOD_COORDINATES: Coordinates = {
  latitude: -33.796,
  longitude: 151.183,
};

export const SURFACE_COVER_CONFIG: SurfaceCoverConfig = {
  url: "https://chatswood-demo-v2.s3.ap-southeast-2.amazonaws.com/chatswood-demo/chatswood_surface_cover.png",
  coordinates: [
    [151.159394, -33.783892], // top-left
    [151.203314, -33.784539], // top-right
    [151.202833, -33.807472], // bottom-right
    [151.158903, -33.806825], // bottom-left
  ],
};
